import React from 'react';
import { Grid, CssBaseline, Toolbar } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Rodape from 'components/Rodape';
import Sidebar from 'pages/Admin/Sidebar';

const AdminLayout = () => {
    return (
        <Grid container style={{ minHeight: '100vh' }}>
            <CssBaseline />
            <Grid item>
                <Sidebar />
            </Grid>
            <Grid item style={{ flexGrow: 1 }}>
                <Toolbar />
                <Outlet />
            </Grid>
            <Grid item xs={12}>
                <Rodape />
            </Grid>
        </Grid>
    );
};

export default AdminLayout;
